// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1643":"294a497239f0438e","6460":"420a9e641ec7741d"}[chunkId] + ".css";
};